import MyRouter from './components/router/MyRouter';
import AuthProvider from './providers/AuthProvider';
import FaunaProvider from './providers/FaunaProvider';
import GlobalStyle from './styles/GlobalStyle';
import './styles/common/popup-anime.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import 'rsuite/dist/rsuite.min.css';
import { CustomProvider } from 'rsuite';
import { QueryClient, QueryClientProvider } from 'react-query';


const queryClient = new QueryClient()

function App() {
  return (
    <>
      <GlobalStyle />
      <QueryClientProvider client={queryClient}>
        <CustomProvider theme="dark">
          <AuthProvider>
              <FaunaProvider>
                <MyRouter />
              </FaunaProvider>
          </AuthProvider>
        </CustomProvider>
      </QueryClientProvider>
      <ToastContainer />
    </>
  );
}

export default App;
